var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "work_outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6.00018V4.00018H10V6.00018H14ZM4 8.00018V19.0002H20V8.00018H4ZM20 6.00018C21.11 6.00018 22 6.89018 22 8.00018V19.0002C22 20.1102 21.11 21.0002 20 21.0002H4C2.89 21.0002 2 20.1102 2 19.0002L2.01 8.00018C2.01 6.89018 2.89 6.00018 4 6.00018H8V4.00018C8 2.89018 8.89 2.00018 10 2.00018H14C15.11 2.00018 16 2.89018 16 4.00018V6.00018H20Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkOutline);
export default __webpack_public_path__ + "static/media/work_outline.913e71a672d944fe5c543238b04c8a24.svg";
export { ForwardRef as ReactComponent };